

import Gallery from '../../../../modules/Gallery';


import foto_1 from './foto_1.jpg'
import foto_2 from './foto_2.jpg'
import foto_3 from './foto_3.jpg'
import foto_4 from './foto_4.jpg'
import foto_5 from './foto_5.jpg'
import foto_6 from './foto_6.jpg'
import foto_7 from './foto_7.jpg'
import foto_8 from './foto_8.jpg'


const slides = [
    {
      src: foto_1,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_2,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_3,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_4,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_5,
      title: 'Slide Title One',
      description: 'Slide Description One\n\nthis is new line',
    },
    {
      src: foto_6,
      title: 'Slide Title Two',
      description: 'Slide Description Two',
    },
    {
      src: foto_7,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    },
    {
      src: foto_8,
      title: 'Slide Title Three',
      description: 'Slide Description Three',
    }
]



export default function Index() {

    return (
        <div className='container'>

            <div className='mt-3'>
                <h3>Economia solidaria y construcción de tejido social 2023
</h3>
                <p>
                    COOPMULMAG, en el marco de su compromiso con la formación integral 
                    de sus asociados, desarrolla espacios educativos orientados al fortalecimiento 
                    de la economía solidaria y la construcción de tejido social. Esta jornada de 
                    capacitación reafirma nuestra misión de promover valores cooperativos, participación 
                    activa y desarrollo comunitario sostenible.</p>
            </div>
            <Gallery slides={slides} ></Gallery>
        </div>
    )

}